module.exports = __webpack_public_path__ + "static/media/t3.c1780df0.png";